import { Component, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSquare, faRss, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookF,
  faYoutube,
  faXTwitter,
  faLinkedinIn,
  faInstagram,
  faSquareFacebook,
  faSquareXTwitter
} from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  constructor() {}
  faFacebook = faSquareFacebook;
  faX = faSquareXTwitter;
  faYoutube = faYoutube;
  faInstagram = faInstagram;
  faLinkedIn = faLinkedinIn;
  faPlus = faPlus;
  faMinus = faMinus;

  ngOnInit() {
    const currYear: any = document.querySelector('.current-year');
    if (currYear) currYear.textContent = new Date().getFullYear();
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
